import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetRealtorRatingList, EResetRealtorRatingListActionType } from './types';

export const resetRealtorRatingList: () => TResetRealtorRatingList =
  actionGenerator<EResetRealtorRatingListActionType.Reset>(EResetRealtorRatingListActionType.Reset);
